import { render, staticRenderFns } from "./DashboardDocumentTable.vue?vue&type=template&id=8d3d7ddc&scoped=true&"
import script from "./DashboardDocumentTable.vue?vue&type=script&lang=js&"
export * from "./DashboardDocumentTable.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDocumentTable.vue?vue&type=style&index=0&id=8d3d7ddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3d7ddc",
  null
  
)

export default component.exports